import React, { Component } from 'react';
import { Icon } from 'react-materialize';
import Indicator from '../data/IndicatorValueMap';
import DataSource from '../data/DataSource';


class SourcesCollapsible extends Component {
  constructor(props) {
   super(props);
   this.state = {
     collapsible: true
   }
 }

 onClickCollapsible(){
   let temp = this.state.collapsible;
   this.setState({ collapsible: !temp })
 }

renderSource(source){
var link1 = DataSource[`${source}-link1`]
var link2 = DataSource[`${source}-link2`]
var source = DataSource[source].split('%%')
// console.log(source.length);
// <a href={link1} target='_blank'>{link1}</a>
// <a href={link1} target='_blank'>{link2}</a>
return <div style={{wordWrap: "break-word"}}>{
          source.length < 5?
          <p>
            {source[0]}<span className= 'italic'>{source[1]}</span>{source[2]}
          </p>: source.length === 5?
          <p>
            {source[0]}<span className= 'italic'>{source[1]}</span>{source[2]}<a href={source[3]} target='_blank'>{source[3]}</a>{source[4]}
          </p> :
          <p>
          {source[0]}
          <span className= 'italic'>{source[1]}</span>
          {source[2]}
          <a href={source[3]} target='_blank'>{source[3]}</a>
          {source[4]}
          <a href={source[5]} target='_blank'>{source[5]}</a>
          {source[6]}
          </p>
        }</div>

}

render() {
  //console.log(this.props.indicatorValue);
  var sources = [];
  var links = [];
  if (this.props.indicatorValue){
    sources = Indicator[`${this.props.indicatorValue}-source`].split('&&');
  }
  return (
    <div className="map-view-collapsible">
      <div className="map-view-collapsible-title" onClick={() => this.onClickCollapsible()}>
        <div className="view-text">
          <span style={{display: 'flex', alignItems: "center"}}>
            Data Sources
          </span>
        </div>
        <div className="view-icon">
          {
            this.state.collapsible? <Icon>keyboard_arrow_up</Icon>:<Icon>keyboard_arrow_down</Icon>
          }
        </div>
      </div>
      <div>
        {
          this.state.collapsible?
              sources.map(source =>
              <div style={{margin: "2%"}}>
                {this.renderSource(source)}
              </div>
              )
            : ""
        }
      </div>
    </div>
  )}
}

export default SourcesCollapsible;



// WEBPACK FOOTER //
// ./src/components/SourcesCollapsible.js